class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });

    if (window.updateKikCartDrawerTotal) {
      window.updateKikCartDrawerTotal(parsedState);
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);




/*function formatMoneyFromCents(cents) {
  if (!Number.isFinite(cents)) return null;

  if (window.Shopify && typeof Shopify.formatMoney === 'function') {
    const formatString =
      (window.Shopify.currency && window.Shopify.currency.active && window.Shopify.money_with_currency_format) ||
      window.Shopify.money_format ||
      '${{amount}}';
    return Shopify.formatMoney(cents, formatString);
  }

  const currency = window.Shopify?.currency?.active || 'USD';
  try {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency });
  } catch (error) {
    return `${currency} ${(cents / 100).toFixed(2)}`;
  }
}

function getCartTotalFromState(cartState) {
  if (!cartState) return undefined;

  if (typeof cartState.total_price === 'number' && Number.isFinite(cartState.total_price)) {
    return cartState.total_price;
  }

  if (typeof cartState.cart?.total_price === 'number' && Number.isFinite(cartState.cart.total_price)) {
    return cartState.cart.total_price;
  }

  if (Array.isArray(cartState.items) && cartState.items.length) {
    const sum = cartState.items.reduce((total, item) => {
      const linePrice =
        typeof item.original_line_price === 'number'
          ? item.original_line_price
          : typeof item.final_line_price === 'number'
            ? item.final_line_price
            : typeof item.line_price === 'number'
              ? item.line_price
              : 0;
      return total + linePrice;
    }, 0);

    if (Number.isFinite(sum)) {
      return sum;
    }
  }

  return undefined;
}


function updateKikCartDrawerTotal(cartState) {
  // 1. Get the final price from the API (includes the $30 discount)
  const totalPrice = getCartTotalFromState(cartState);
  
  const totalValueElement = document.querySelector('#kik_total_price_value');
  const compareValueElement = document.querySelector('#kik_total_compare_at_value');

  if (totalValueElement && typeof totalPrice === 'number') {
    totalValueElement.innerHTML = formatMoneyFromCents(totalPrice);
  }

  // 2. Calculate the Total Compare-at Price using your new dataset
  let totalCompareAtCents = 0;
  const cartItems = document.querySelectorAll('.cart-item');

  cartItems.forEach((item) => {
    // Get quantity from the live input field
    const quantityInput = item.querySelector('input.quantity__input');
    const quantity = quantityInput ? parseInt(quantityInput.value) : 0;

    // Get the SINGLE item compare price from your data attribute
    const oldPriceContainer = item.querySelector('.cart-item__old-price[data-compare]');
    const regularPriceElement = item.querySelector('.price--end .money');

    if (oldPriceContainer) {
      // Logic: Single Unit Compare Price * Current Quantity
      const unitComparePrice = parseInt(oldPriceContainer.getAttribute('data-compare'));
      totalCompareAtCents += (unitComparePrice * quantity);
    } else if (regularPriceElement) {
      // Fallback: If no compare price, use the regular price for this line
      const unitRegularPrice = parseInt(regularPriceElement.textContent.replace(/[^0-9]/g, ''));
      // Note: If your regularPriceElement already shows the line total, don't multiply by quantity
      // If it's the single unit price, multiply it:
      totalCompareAtCents += unitRegularPrice; 
    }
  });

  // 3. Update the Compare-at Total UI
  if (compareValueElement) {
    if (totalCompareAtCents > totalPrice) {
      compareValueElement.innerHTML = formatMoneyFromCents(totalCompareAtCents);
      compareValueElement.style.display = 'inline';
    } else {
      compareValueElement.style.display = 'none';
    }
  }
}

window.formatMoneyFromCents = window.formatMoneyFromCents || formatMoneyFromCents;
window.updateKikCartDrawerTotal = window.updateKikCartDrawerTotal || updateKikCartDrawerTotal;

if (typeof subscribe === 'function') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (!event) return;
    updateKikCartDrawerTotal(event.cartData || event);
  });
}

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: 'CartDrawer',
//         section: 'cart-drawer',
//         selector: '.drawer__inner',
//       },
//       {
//         id: 'cart-icon-bubble',
//         section: 'cart-icon-bubble',
//         selector: '.shopify-section',
//       },
//     ];
//   }
// }

// customElements.define('cart-drawer-items', CartDrawerItems);
*/
